import React from 'react'
import styled from 'styled-components'
import CommonText from '../common/CommonText'
import CommonImage from '../common/CommonImage'

const Ingredient = () => {
  return (
    <IngredientWrapper>
      <CommonImage
        width={58}
        hegiht={58}
        block
        style={{ borderRadius: '100%', marginBottom: '5px' }}
        src="https://t1.daumcdn.net/cfile/tistory/167142474F3C31D208"
      />
      <CommonText tag="div">베이컨</CommonText>
    </IngredientWrapper>
  )
}

const IngredientWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 58px;
  height: 74px;
  margin-bottom: 30px;
`

export default Ingredient
